import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Portfolio from "@/pages/Portfolio";
import Packages from "@/pages/Packages";
import LifeLegacy from "@/pages/LifeLegacy";
import BrandBusiness from "@/pages/BrandBusiness";
import BusinessArizona from "@/pages/BusinessArizona";
import AestheticClinic from "@/pages/AestheticClinic";
import HomeServices from "@/pages/HomeServices";
import Video from "@/pages/Video";
import Workshops from "@/pages/Workshops";
import Prints from "@/pages/Prints";
import PrintDetail from "@/pages/PrintDetail";
import Reviews from "@/pages/Reviews";
import About from "@/pages/About";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import Inquire from "@/pages/Inquire";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Home />} />
                        <Route path="life-legacy" element={<LifeLegacy />} />
                        <Route path="brand-business" element={<BrandBusiness />} />
                        <Route path="business" element={<BusinessArizona />} />
                        <Route path="arizona-business-photography" element={<Navigate to="/business" replace />} />
                        {/* Phase 12 — Campaign landing page for medical / aesthetic /
                            wellness practices. Unlisted in top nav; reachable
                            directly and via the /business clinic tile. Crawlable. */}
                        <Route path="aesthetic-clinic-photography" element={<AestheticClinic />} />
                        {/* Home-Services campaign landing page (HVAC, plumbing,
                            electrical, roofing, trades in Arizona). Unlisted in
                            top nav; reachable directly and via the /business
                            home-services tile. Crawlable. */}
                        <Route path="home-services-photography" element={<HomeServices />} />
                        <Route path="branding" element={<Navigate to="/brand-business" replace />} />
                        <Route path="portfolio" element={<Portfolio />} />
                        <Route path="portfolio/:scope" element={<Portfolio />} />
                        <Route path="packages" element={<Packages />} />
                        <Route path="video" element={<Video />} />
                        <Route path="mentoring" element={<Workshops />} />
                        <Route path="workshops" element={<Navigate to="/mentoring" replace />} />
                        <Route path="atelier" element={<Prints />} />
                        <Route path="atelier/:id" element={<PrintDetail />} />
                        <Route path="prints" element={<Navigate to="/atelier" replace />} />
                        <Route path="prints/:id" element={<PrintDetail />} />
                        <Route path="reviews" element={<Reviews />} />
                        <Route path="about" element={<About />} />
                        <Route path="journal" element={<Journal />} />
                        <Route path="journal/:slug" element={<JournalPost />} />
                        <Route path="inquire" element={<Inquire />} />
                        <Route path="admin/login" element={<AdminLogin />} />
                        <Route path="admin" element={<Admin />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
